export function getHealthCommand(backendURL, APIKey) {
  return `curl -X GET '${backendURL}/api/v1/health' -H 'Authorization: Bearer ${APIKey}'`;
}
